import 'src/bootstrap';
import router from 'src/router';
import store from 'src/store';
import 'src/global-components';
import PortalVue from 'portal-vue';
import Meta from 'vue-meta';
import 'src/register-service-worker';
import bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';
import eventBus from 'src/util/eventBus';

if (process.env.NODE_ENV === 'production') {
    const bugsnagClient = bugsnag('0d02c88a1133e98de1902990240be599');

    bugsnagClient.use(bugsnagVue, Vue);
}

Vue.use(PortalVue);
Vue.use(Meta);

let deferredPrompt = null;

window.addEventListener('beforeinstallprompt', e => {
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later.
    deferredPrompt = e;

    // console.log('beforeinstallprompt event fired');
});

new Vue({
    store,
    router,
    data: {
        appLoaded: false,
        transitionName: '',
        isMobile: null,
        appBasePath: process.env.MIX_APP_BASE_PATH,
    },
    created() {
        this.appLoaded = true;

        this.$router.beforeEach((to, from, next) => {
            const toDepth = to.path.split('/').length;
            const fromDepth = from.path.split('/').length;

            this.transitionName =
                toDepth < fromDepth ? 'slide-right' : 'slide-left';

            this.trackPage(to);

            next();
        });
    },
    mounted() {
        this.listenForMobile();
        this.listenForPrinting();
    },
    methods: {
        listenForPrinting() {
            if (typeof window.onbeforeprint === 'undefined') {
                const mediaQueryList = window.matchMedia('print');

                mediaQueryList.addEventListener('change', function(mql) {
                    if (mql.matches) {
                        eventBus.$emit('beforeprint');
                    }
                });
            } else {
                this.beforePrintListener = window.addEventListener(
                    'beforeprint',
                    () => {
                        eventBus.$emit('beforeprint');
                    },
                );

                this.afterPrintListener = window.addEventListener(
                    'afterprint',
                    () => {
                        eventBus.$emit('afterprint');
                    },
                );
            }
        },
        trackPage(route) {
            if (!process.env.MIX_GOOGLE_ANALYTICS_CODE) {
                return;
            }

            if (typeof window.gtag === 'undefined') {
                return setTimeout(() => this.trackPage(route), 1000);
            }

            // Allow time for the document title to update before pushing new page
            setTimeout(() => {
                window.gtag('config', process.env.MIX_GOOGLE_ANALYTICS_CODE, {
                    page_path: `/${process.env.MIX_APP_BASE_PATH}${route.path}`,
                    page_title: document.title,
                });
            }, 100);
        },
        listenForMobile() {
            const mediaQuery = window.matchMedia('(max-width: 900px)');

            this.isMobile = mediaQuery.matches;

            mediaQuery.addEventListener('change', event => {
                this.isMobile = event.matches;
            });
        },
        beforeEnter(el) {
            el.style.top = null;
        },
        beforeLeave(el) {
            el.style.top = `${el.getBoundingClientRect().top}px`;
        },
        afterLeave(el) {
            el.style.top = null;
        },
    },
}).$mount('#app');
